import { StringKey } from '../../../../lang/index';

export enum SignatureSortBy {
  EXPIRES_AT = 'expiresAt',
  LAST_SENT_AT = 'lastSentAt',
  NAME = 'name',
}

export const signatureSortByTranslationKey: Record<SignatureSortBy, StringKey> = {
  [SignatureSortBy.NAME]: 'DOCUMENT_NAME',
  [SignatureSortBy.LAST_SENT_AT]: 'SORT_LAST_SENT',
  [SignatureSortBy.EXPIRES_AT]: 'SORT_EXPIRY',
};
